import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addContact } from '@/actions/home';
import { Button, Col, Row, notification } from 'antd';
import { blockInvalidChar } from '@/helpers/formDataHelper';
import { useRouter } from 'next/router';
import { CountryCodeSelector } from '@/helpers/CountryCodeSelector';

function ContactContent({ office }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const status = useSelector((state: any) => state?.home?.contact?.status);

  const [data, setData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    subject: '',
    message: '',
    campaign: [],
    country: '',
    city: '',
    country_code: '+977',
  });

  useEffect(() => {
    if (router.query.campaign) {
      setData({ ...data, campaign: [router.query.campaign.toString()] });
    }
  }, [router.query]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const newData = {
      first_name: data?.first_name,
      last_name: data?.last_name,
      email: data?.email,
      subject: data?.subject,
      message: data?.message,
      campaign: data?.campaign,
      address: `${data?.country}, ${data?.city}`,
      phone_number: `${data?.country_code}-${data?.phone_number}`,
    };
    dispatch(addContact(newData));
    setData({
      ...data,
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      subject: '',
      message: '',
      country: '',
      city: '',
      country_code: '+977',
    });
  };
  useEffect(() => {
    if (status) {
      notification.success({
        message: 'Thank you! Inquiry Successfully submitted.',
      });
    }
  }, [status]);

  return (
    <section className="my-4 py-4">
      <div className="custom-container">
        <Row gutter={12} className="d-flex justify-content-between">
          {/* Contact Form */}
          <Col
            lg={{ span: 11 }}
            md={{ span: 11 }}
            sm={{ span: 24 }}
            className="border rounded-lg shadow-none p-4 gutter-row mb-4"
          >
            <h3>Get in Touch !</h3>
            <form id="contactForm" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className=" col-lg-6 col-md-12">
                  <div className="form-group">
                    <input
                      value={data.first_name}
                      onChange={(e) =>
                        setData({ ...data, first_name: e.target.value })
                      }
                      type="text"
                      className="form-control w-100"
                      placeholder="First Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <input
                      value={data.last_name}
                      onChange={(e) =>
                        setData({ ...data, last_name: e.target.value })
                      }
                      type="text"
                      className="form-control w-100"
                      placeholder="Last Name"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-12 col-md-12">
                  <div className="form-group">
                    <input
                      type="email"
                      value={data.email}
                      onChange={(e) => setData({ ...data, email: e.target.value })}
                      className="form-control w-100"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-4 col-md-12 mb-2">
                  <CountryCodeSelector
                    onChange={(val) => {
                      setData({ ...data, country_code: val });
                    }}
                    defaultValue={'+977'}
                  />
                </div>
                <div className="col-lg-8 col-md-12">
                  <div className="form-group">
                    <input
                      type="number"
                      value={data.phone_number}
                      onChange={(e) =>
                        setData({ ...data, phone_number: e.target.value })
                      }
                      className="form-control w-100"
                      placeholder="Phone Number"
                      required
                      onKeyDown={blockInvalidChar}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <input
                      type="text"
                      value={data.country}
                      onChange={(e) => setData({ ...data, country: e.target.value })}
                      className="form-control w-100"
                      placeholder="Country"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="form-group">
                    <input
                      type="text"
                      value={data.city}
                      onChange={(e) => setData({ ...data, city: e.target.value })}
                      className="form-control w-100"
                      placeholder="City"
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  value={data.subject}
                  onChange={(e) => setData({ ...data, subject: e.target.value })}
                  className="form-control w-100"
                  placeholder="Preferred Course"
                  required
                />
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  value={data.message}
                  className="form-control w-100"
                  placeholder="Your Message"
                  onChange={(e) => setData({ ...data, message: e.target.value })}
                  required
                  style={{ resize: 'none' }}
                ></textarea>
              </div>

              <div className="contact-send-btn text-center">
                <Button
                  className="btn-secondary border-danger"
                  size="large"
                  htmlType="submit"
                >
                  Send Message
                </Button>
              </div>
            </form>
          </Col>

          {/* Information */}
          <Col
            lg={{ span: 12 }}
            md={{ span: 12 }}
            sm={{ span: 24 }}
            className="border rounded-lg shadow-none p-4 gutter-row mb-4"
          >
            <div className="row">
              <h3 className="text-center" style={{ marginBottom: '40px' }}>
                Our Office
              </h3>

              {office?.phone_number ? (
                <div className="col-lg-12 col-md-12 mb-4 h-100">
                  <div className="d-flex contact-box border shadow-none">
                    <div className="icon">
                      <i className="fa fa-phone"></i>
                    </div>
                    <div className="content">
                      <h4>Phone</h4>
                      <p>{office?.phone_number}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              {office?.email ? (
                <div className="col-lg-12 col-md-12 mb-4 h-100">
                  <div className="contact-box border shadow-none">
                    <div className="icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="content">
                      <h4>E-mail</h4>
                      <p style={{ wordBreak: 'break-all' }}>{office?.email}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              {office?.country ? (
                <div className="col-lg-12 col-md-12 mb-4">
                  <div className="contact-box border shadow-none">
                    <div className="icon ">
                      <i className="fa fa-map-marker"></i>
                    </div>
                    <div className="content">
                      <h4>Location</h4>
                      <p>
                        {office?.street ? office?.street + ', ' : ''}
                        {office?.city ? office?.city + ', ' : ''} {office?.country}{' '}
                        {office?.postal_code ? '(' + office?.postal_code + ')' : ''}
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}
export default ContactContent;
